export default __webpack_public_path__ + "static/media/12.beff0bc7.png";